module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (220).66567776.jpg";